const initialState = {};

export default function errorBoundaryReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ERROR_BOUNDARY":
      return action.payload;
    case "CLEAR_ERROR_BOUNDARY":
      return {};
    default:
      return state;
  }
}
